<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o1SYnW/tc-custom/9781035843596.jpg?1718106717281" alt="This image is the cover for the book When Life Changes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Life Changes
      </h1>
      <p class="bookDescription body article font2">
        <p>Life in the Far East is a melting pot of diverse cultures, where romance takes many forms. This story follows young adults who forge cross-cultural friendships in Thailand. Faced with discrimination, injustice, bribery, and other difficulties, they navigate complex decisions about integrity and honour. Saving face and upholding family reputation prove challenging, especially when misunderstandings arise. Each character uniquely combats obstacles as relationships deepen. When change occurs, responses vary. Ultimately, the question emerges: Can their love withstand the heat of social forces? While fictional, the protagonists are composites of real-life individuals. Their poignant interactions unveil profound truths about facing adversity in rapidly modernizing societies. Readers are transported to the realities of the region, exploring moral dilemmas through sympathetic eyes as values intermix amidst the confusion of progress.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Birgit Forsberg
      </h2>
      
      <p class="authorDescription body article">Born and raised in Asia of Finnish missionary parents, Birgit Forsberg has lived most of her life in Asia, first in Sri Lanka and then in Thailand, working as a missionary and a housewife. After the unexpected death of her Thai-Chinese husband, she moved to her home country, where she has worked as a registered nurse until retirement. A mother of three children and a grandmother of one nephew, she now works part-time. She lives with her husband, Johan, and their dog in a small town in Finland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c5ffbd4